var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-divider"
  }, [_c('el-button', {
    staticClass: "remove-btn f-edit",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.removeItem(_vm.ruleForm)
      }
    }
  }, [_c('span', {
    staticClass: "color-danger"
  }, [_vm._v("删除")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    class: [{
      'form-view': !_vm.isEdit
    }, 'form-switch', 'form-col'],
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "col-2 clearfix"
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司名称:",
      "prop": "company"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.company)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入公司名称"
    },
    model: {
      value: (_vm.ruleForm.company),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "company", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位名称:",
      "prop": "position"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.ruleForm.position)
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "f-edit",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入职位名称"
    },
    model: {
      value: (_vm.ruleForm.position),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "position", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.position"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-form-item', {
    staticClass: "width-longer",
    attrs: {
      "label": "工作时间:"
    }
  }, [_c('p', {
    staticClass: "f-view",
    domProps: {
      "textContent": _vm._s(_vm.durationDateText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "f-edit"
  }, [_c('el-date-picker', {
    ref: "startDate",
    attrs: {
      "type": "month",
      "placeholder": "开始时间",
      "picker-options": _vm.startDateOption
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.ruleForm.beginDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "beginDate", $$v)
      },
      expression: "ruleForm.beginDate"
    }
  }), _vm._v("\n                    至\n                    "), _c('el-date-picker', {
    ref: "endDate",
    attrs: {
      "type": "month",
      "placeholder": "结束时间",
      "picker-options": _vm.endDateOption
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.ruleForm.endDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "endDate", $$v)
      },
      expression: "ruleForm.endDate"
    }
  })], 1)])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1e0ce4a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/items/work.vue
// module id = null
// module chunks = 